// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__vpsSB","unassignedEfaxes":"InboxSidebar_unassignedEfaxes___-_a9"};